import { IconButton } from "@mui/material";

interface Props {
  title: string;
  icon: any;
  onClick: () => void;
}

export default function CalendarToolButton({ title, icon, onClick }: Props) {
  return (
    <IconButton
      title={title}
      size="small"
      onClick={() => {
        onClick();
      }}
    >
      {icon}
    </IconButton>
  );
}
